<template>
  <div class="replacement-card-item">
    <h2>Kaart {{ formattedEngravedId }}</h2>
    <div class="row">
      <div class="small-12 medium-12 columns">
        <div class="gridelement formsectioncompound small-12 wm-field columns">
          <div class="wm-field-label">
            <label :for="`form[${initialFormData.cardId}][engravedId]`">{{ getFieldLabel('engravedId') }}</label>
          </div>
          <div class="wm-field-input">
            <input
              :name="`replacement-card-form[${initialFormData.cardId}][engravedId]`"
              :value="formattedEngravedId"
              disabled="disabled"
              type="text">
          </div>
        </div>
      </div>
    </div>
    <div v-if="isPersonalCard" class="row">
      <div class="small-12 medium-4 columns">
        <select-field
          :id="`replacementCard-${initialFormData.cardId}-cardHolderDetails-gender`"
          :$v="$v.initialFormData.cardHolderDetails.gender"
          :value="initialFormData.cardHolderDetails.gender"
          :options="genderOptions"
          :required="true"
          :label="getFieldLabel('gender', true)"
          :name="`replacement-card-form[${initialFormData.cardId}][cardHolderDetails][gender]`"
          @change="(v) => updateFormCardHolderDetailsProperty('gender', v)"
        />
      </div>
      <div class="small-12 medium-4 columns">
        <input-field
          :id="`replacementCard-${initialFormData.cardId}-cardHolderDetails-firstName`"
          :$v="$v.initialFormData.cardHolderDetails.firstName"
          :value="initialFormData.cardHolderDetails.firstName"
          :required="true"
          :maxlength="12"
          :normalization-filter="filters.initials"
          :label="getFieldLabel('firstName', true)"
          :name="`replacement-card-form[${initialFormData.cardId}][cardHolderDetails][firstName]`"
          @input="(v) => updateFormCardHolderDetailsProperty('firstName', v)"
        />
      </div>
      <div class="small-12 medium-4 columns">
        <input-field
          :id="`replacementCard-${initialFormData.cardId}cardHolderDetails-surnamePrefix`"
          :$v="$v.initialFormData.cardHolderDetails.surnamePrefix"
          :value="initialFormData.cardHolderDetails.surnamePrefix"
          :required="false"
          :maxlength="8"
          :label="getFieldLabel('surnamePrefix', false)"
          :name="`replacement-card-form[${initialFormData.cardId}][cardHolderDetails][surnamePrefix]`"
          @input="(v) => updateFormCardHolderDetailsProperty('surnamePrefix', v)"
        />
      </div>
    </div>
    <div v-if="isPersonalCard" class="row">
      <div class="small-12 medium-6 columns">
        <input-field
          :id="`replacementCard-${initialFormData.cardId}-cardHolderDetails-surname`"
          :$v="$v.initialFormData.cardHolderDetails.surname"
          :value="initialFormData.cardHolderDetails.surname"
          :required="true"
          :maxlength="50"
          :normalization-filter="filters.capitalize"
          :label="getFieldLabel('surname', true)"
          :name="`replacement-card-form[${initialFormData.cardId}][cardHolderDetails][surname]`"
          @input="(v) => updateFormCardHolderDetailsProperty('surname', v)"
        />
      </div>
      <div class="small-12 medium-6 columns">
        <input-field
          :id="`replacementCard-${initialFormData.cardId}-cardHolderDetails-dateOfBirth`"
          :$v="$v.initialFormData.cardHolderDetails.dateOfBirth"
          :value="initialFormData.cardHolderDetails.dateOfBirth"
          :required="false"
          :maxlength="10"
          :label="getFieldLabel('dateOfBirth', true)"
          :name="`replacement-card-form[${initialFormData.cardId}][cardHolderDetails][dateOfBirth]`"
          :normalization-filter="filters.maskDateInput"
          @input="(v) => updateFormCardHolderDetailsProperty('dateOfBirth', v)"
        />
      </div>
    </div>
    <div class="row">
      <div class="small-12 medium-4 columns">
        <input-field
          :id="`replacementCard-${initialFormData.cardId}-ascription`"
          :$v="$v.initialFormData.ascription"
          :value="initialFormData.ascription"
          :required="false"
          :maxlength="255"
          :label="getFieldLabel('ascription', false)"
          :name="`replacement-card-form[${initialFormData.cardId}][ascription]`"
          @input="(v) => updateFormProperty('ascription', v)"
        />
      </div>
      <div class="small-12 medium-4 columns">
        <input-field
          :id="`replacementCard-${initialFormData.cardId}-ascription1`"
          :$v="$v.initialFormData.ascription1"
          :value="initialFormData.ascription1"
          :required="false"
          :maxlength="255"
          :label="getFieldLabel('ascription1', false)"
          :name="`replacement-card-form[${initialFormData.cardId}][ascription1]`"
          @input="(v) => updateFormProperty('ascription1', v)"
        />
      </div>
      <div class="small-12 medium-4 columns">
        <input-field
          :id="`replacementCard-${initialFormData.cardId}-ascription2`"
          :$v="$v.initialFormData.ascription2"
          :value="initialFormData.ascription2"
          :required="false"
          :maxlength="255"
          :label="getFieldLabel('ascription2', false)"
          :name="`replacement-card-form[${initialFormData.cardId}][ascription2]`"
          @input="(v) => updateFormProperty('ascription2', v)"
        />
      </div>
    </div>
    <div class="row">
      <div class="small-12 medium-12 columns">
        <div class="gridelement formsectioncompound small-12 wm-field columns">
          <div class="wm-field-label">
            <label :for="`form[${initialFormData.cardId}][defaultCompanyNameOnCard]`">
              {{ getFieldLabel('defaultCompanyNameOnCard') }}
            </label>
          </div>
          <div class="wm-field-input">
            <input
              :name="`replacement-card-form[${initialFormData.cardId}][defaultCompanyNameOnCard]`"
              :value="initialFormData.defaultCompanyNameOnCard"
              disabled="disabled"
              type="text">
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="small-12 medium-12 columns">
        <select-field
          :id="`replacementCard-${initialFormData.cardId}-cardTheme`"
          :$v="$v.initialFormData.cardTheme"
          :value="initialFormData.cardTheme"
          :options="cardThemeOptions"
          :required="true"
          :label="getFieldLabel('cardTheme', true)"
          :name="`replacement-card-form[${initialFormData.cardId}][cardTheme]`"
          @change="(v) => updateFormProperty('cardTheme', v)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { maxLength, required } from 'vuelidate/lib/validators'
import InputField from './fields/InputField'
import SelectField from './fields/SelectField'
import engravedId from '../../filters/engraved-id'
import customFilters from '../../filters'
import DatePickerField from './fields/DatePickerField'
import {CardThemeMapping} from '../../types/card-theme'
import {GenderMapping} from '../../types/gender'
import {CARD_TYPE_PERSONAL} from '../../types/card-type'
import {date} from '../../validators'
import { mapMutations } from 'vuex'
import {
  SET_FORM_DATA_ITEM_PROPERTY,
  SET_FORM_DATA_ITEM_CARD_HOLDER_DETAILS_PROPERTY
} from '../../store/modules/order-replacement-card/mutation-types'

export default {
  name: 'ReplacementCardSubForm',
  components: {
    InputField,
    SelectField,
    DatePickerField
  },
  props: {
    initialFormData: {
      type: Object,
      required: true
    }
  },
  data: () => {
    return {
      filters: {
        capitalize: customFilters.capitalize,
        initials: customFilters.initials,
        maskDateInput: customFilters.maskDateInput
      }
    }
  },
  computed: {
    isPersonalCard () {
      return this.initialFormData.cardType === CARD_TYPE_PERSONAL
    },
    cardThemeOptions () {
      const cardThemeOptions = [{value: '', text: this.$t('generic.select')}]

      Object.keys(CardThemeMapping).map(cardTheme => {
        cardThemeOptions.push({
          value: CardThemeMapping[cardTheme],
          text: this.$t(`generic.cardTheme.${cardTheme}`)
        })
      })

      return cardThemeOptions
    },
    genderOptions () {
      const genderOptions = [{value: '', text: this.$t('generic.select')}]

      Object.values(GenderMapping).map(gender => {
        genderOptions.push({
          value: gender,
          text: this.$t(`generic.gender.${gender}`)
        })
      })

      return genderOptions
    },
    formattedEngravedId () {
      return engravedId(this.initialFormData.engravedId)
    }
  },
  validations () {
    const validations = {
      initialFormData: {
        ascription: {
          maxLength: maxLength(255)
        },
        ascription1: {
          maxLength: maxLength(255)
        },
        ascription2: {
          maxLength: maxLength(255)
        },
        cardTheme: {
          required
        }
      }
    }

    if (this.isPersonalCard) {
      validations.initialFormData.cardHolderDetails = {
        gender: {
          required
        },
        firstName: {
          required,
          maxLength: maxLength(30)
        },
        surnamePrefix: {
          maxLength: maxLength(8)
        },
        surname: {
          required,
          maxLength: maxLength(50)
        },
        dateOfBirth: {
          required,
          date
        }
      }
    }

    return validations
  },
  methods: {
    ...mapMutations('orderReplacementCard', {
      setFormDataProperty: SET_FORM_DATA_ITEM_PROPERTY,
      setFormDataItemCardHolderDetailsProperty: SET_FORM_DATA_ITEM_CARD_HOLDER_DETAILS_PROPERTY
    }),
    getFieldLabel (fieldName, isFieldRequired) {
      return this.$t(`orderReplacementCard.formFields.${fieldName}`) + (isFieldRequired ? ' *' : '')
    },
    touchValidation () {
      return this.$v.$touch()
    },
    isInvalid () {
      return this.$v.$invalid
    },
    updateFormCardHolderDetailsProperty (property, value) {
      this.setFormDataItemCardHolderDetailsProperty({formDataItem: this.initialFormData, property, value})
    },
    updateFormProperty (property, value) {
      this.setFormDataProperty({formDataItem: this.initialFormData, property, value})
    }
  }
}
</script>

<style scoped>
  .replacement-card-item:first-of-type {
    margin-top: 20px;
  }

  .replacement-card-item {
    margin-bottom: 40px;
  }
</style>



// WEBPACK FOOTER //
// src/components/forms/ReplacementCardSubForm.vue